import { Observable } from 'rxjs';

import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseRoundService } from '@services/base-round.service';

import { PagedResponse } from '@models/paged-response.model';
import { PredictorQuestion } from '@models/predictor-question.model';
import { PredictorRoundQuestionPredictions } from '@models/predictor-round-question-predictions.model';
import { QuickPickStrategy } from '@models/quick-pick-strategy.enum';
import { RoundDetail } from '@models/round-detail.model';
import { RoundListItem } from '@models/round-list-item.model';
import { RoundStatsSummaryModel } from '@models/round-stats-summary.model';
import { UserPrediction } from '@models/user-prediction.model';
import { UserRoundQuickPrediction } from '@models/user-round-quick-prediction.model';

@Injectable({ providedIn: 'root' })
export class PredictorRoundService extends BaseRoundService<
  RoundDetail,
  PredictorQuestion,
  UserPrediction
> {
  private _roundUrl = `${this._apiUrl}/predictor-rounds`;

  constructor() {
    super('predictor-rounds');
  }

  getPredictorRounds(pageNumber = 1, pageSize = 10): Observable<PagedResponse<RoundListItem>> {
    const params = new HttpParams().set('pageNumber', pageNumber).set('pageSize', pageSize);

    return this.http.get<PagedResponse<RoundListItem>>(this._roundUrl, { params });
  }

  updatePredictions(
    roundUuid: string,
    predictions: PredictorRoundQuestionPredictions[],
  ): Observable<UserPrediction[]> {
    return this.http.put<UserPrediction[]>(`${this._roundUrl}/${roundUuid}/predictions`, {
      predictions,
    });
  }

  getPredictorRoundStatsSummary(roundUuid: string): Observable<RoundStatsSummaryModel> {
    return this.http.get<RoundStatsSummaryModel>(`${this._roundUrl}/${roundUuid}/stats-summary`);
  }

  getQuickPredictions(
    roundUuid: string,
    type: QuickPickStrategy,
  ): Observable<UserRoundQuickPrediction[]> {
    const params = new HttpParams().set('type', type);
    
    return this.http.get<UserRoundQuickPrediction[]>(`${this._roundUrl}/${roundUuid}/quick-predictions`, { params });
  }
}
